import { Center, Portal } from '@chakra-ui/react'
import { EditableStateProvider, ScreenContext, useAuth, useScreen } from '@hb/react'
import {
  APP_HEADER_HEIGHT_PX,
  AppHeader,
  Container,
  CookieBanner,
  LoadingOverlay,
  Menu,
  MessagesWidget,
  PopUpMessageOverlay,
  RootModals,
  siteVersions,
  useFilteredViews,
  useForceColorMode,
  useViewRoutes,
  WebThreadsListProvider,
} from '@hb/react-web'
import { version } from '@hb/shared'
import { Route, Routes } from 'react-router-dom'
import { views } from './views'

const App = () => {
  useForceColorMode()
  const filteredViews = useFilteredViews(views)
  const routes = useViewRoutes(filteredViews)

  const screen = useScreen()
  const { height } = screen

  const loading = useAuth(s => s.loading)
  return (
    <ScreenContext.Provider value={screen}>
      <EditableStateProvider>
        <Portal>
          <WebThreadsListProvider views={filteredViews}>
            <Container
              style={{
                justifyContent: 'flex-start',
                opacity: loading ? 0 : 1,
                transition: `opacity 333ms ease ${loading ? 0 : 333}ms`,
                boxSizing: 'border-box',
                height: '100vh',
                background: siteVersions[version].providersBackground,
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
              }}>
              <AppHeader views={filteredViews} />
              <Center position="relative" w="100%" height={`${height - APP_HEADER_HEIGHT_PX}px`}>
                <Routes>
                  {routes.map(({ path, component }) => (
                    <Route key={path} path={path} Component={component} />
                  ))}
                </Routes>
              </Center>
              <MessagesWidget />
              <Menu views={filteredViews} />
            </Container>
            <RootModals />
            <LoadingOverlay
              style={{ fontSize: '21px', fontFamily: 'Comfortaa' }}
              vertical
              height={100}
              loading={loading}
              text="Hamilton Billing"
            />
            <CookieBanner />
          </WebThreadsListProvider>
        </Portal>
        <PopUpMessageOverlay />
      </EditableStateProvider>
    </ScreenContext.Provider>
  )
}

export default App
